function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ffffff;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M9.117,18.586a1.637,1.637,0,1,1-1.637-1.637,1.637,1.637,0,0,1,1.637,1.637Zm10.911,0a1.637,1.637,0,1,1-1.637-1.637A1.637,1.637,0,0,1,20.028,18.586Zm0-7.092V4.947H6.935A1.091,1.091,0,0,0,5.844,3.856H2.571V4.947H4.753l.82,7.025a2.182,2.182,0,0,0,1.363,3.886H20.028V14.767H6.935a1.091,1.091,0,0,1-1.091-1.091s0-.007,0-.011Z",
  transform: "translate(-2.571 -3.856)"
});

var SvgMetroCartWhite = function SvgMetroCartWhite(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.458,
    height: 16.366,
    viewBox: "0 0 17.458 16.366",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMetroCartWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/metro-cart-white.c69d15fa.svg";
export { ForwardRef as ReactComponent };